import dayjs from 'dayjs';

import { isMobileApp } from '@ecs-uk/web-common-mobile-view-helpers';
import eligibleForCeTrial from '../../actions/ecd/resolvers/eligibleForCeTrial';

const defaultConfiguration = {
  requireSelections: true,
};

export default (state, config = defaultConfiguration) => {
  if (!state.auth.currentUser || (config.requireSelections && !state.conductrics.sels)) {
    return null;
  }
  const isMobile = isMobileApp();

  return {
    customer: {
      customerNumber: state.auth.currentUser.customerNumber,
      customerId: state.auth.currentUser.customerId,
      transformationBetaStatus: state.conductrics.sels?.redesignBetaTest,
      authenticationStatus: true,
      eligibleForTrial: eligibleForCeTrial(state),
      previousScore: state.scores?.data?.[1]?.score ?? null,
      score: state.scores?.data?.[0]?.score ?? null,
      score_band: state.scores?.data?.[0]?.band ?? null,
      score_card_id: state.scores?.data?.[0]?.scoreCardId ?? null,
      startDate: dayjs(state.auth.currentUser.createDt).format('MM/DD/YYYY'),
      isoStartDate: dayjs(state.auth.currentUser.createDt).toISOString(),
      subscriptionType: state.subscriptions?.current?.family,
      boostUplift: state.scores?.data?.[0]?.uplift ?? null,
      billingProvider: state.billing?.billingProvider,
      viewSource: isMobile ? 'app_webview' : 'web',
    },
  };
};
